/* eslint-disable import/prefer-default-export */
/**
 * @description - @coco-platform/init-cli generated template
 * @author - huang.jian <hjj491229492@hotmail.com>
 */

export { default as Graph } from './Graph';
